<template>
  <div>
    <NuxtLayout>
      <div class="page-error row-1 p-top-8 p-bot-7">
        <div
          v-html="
            error.statusCode === 500
              ? $t('errors.500.text')
              : $t('errors.404.text')
          "
        />
        <br />
        <NuxtLink
          :to="
            localePath({
              name: 'index',
            })
          "
          class="simple-underline-hover"
          ><span>Homepage</span></NuxtLink
        >
      </div>
    </NuxtLayout>
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'

const props = defineProps({
  error: {
    type: Object,
    default: () => ({ statusCode: 404 }),
  },
})
console.error(props.error)

const fetchConfiguration = async () => {
  await useAsyncData(() => useStore().fetchConfiguration())
}

onMounted(fetchConfiguration)
onUpdated(fetchConfiguration)

const { lenis } = useLenis()
provide('lenis', lenis)
</script>
